/**
* @name: index
* @author: weiyong
* @date: 2022-10-26 22:14
* @description：index
* @update: 2022-10-26 22:14
*/
<template>
  <div
      :data-flow-log-key="flowLogInstanceKey"
      :style="['--innerWidth:'+props.innerWidth+'px',props.borderRadius?'--borderRadius:'+props.borderRadius+'px;':''+'--remarkWidth:'+(props.remarkWidth||0)+'px;',elCtlStyle]"
      :class="[props.labelPosition,props.remarkPosition?'remarkLeft':'']"
      class="xmInput xmFlowLog h100b">
    <div class="header-bar-log flex-div-bet">
      <div class="log-title" v-if="props.titleShowFlag!==false">审批流程</div>
      <div @click="openFlowImg" v-if="props.showImgFlag!==false" style="cursor: pointer;">
        <span class="remix-icon ri-organization-chart1"></span>
        <span>流转图</span>
      </div>
    </div>
    <XmTimeLine ref="timeLineRef" v-bind="XmFlowLogProps" :queryParams="initQueryUserParams">
    </XmTimeLine>

    <a-modal :footer="null" v-model:visible="shoImgFlag" :width="1080" :height="570" title="流程图">
      <see-simple-flow-img style="height:550px;" :queryParams="initQueryUserParams" :logCtlProps="props" :props="imgProps"/>
    </a-modal>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "xmFlowLogCtl",
});
</script>

<script lang="ts" setup>
import {Modal as AModal} from 'ant-design-vue';
import SeeSimpleFlowImg from "@/main-page-base/ctls/baseCtls/seeSimpleFlowImg/index.vue";
import {usePageModelsStore} from "@/store/modules/pageModels";
import {useCtlStyle} from "@/main-page/hooks/useCtlStyle";
import {useVuexState} from "@/main-page/ctls/hooks/useVuexState";
import {CtlComEnum} from "@/main-page/enums/ctlComEnum";
import XmFlowLogProps from './props/xmFlowLogProps';
import XmTimeLine from '@/main-page-base/ctls/dataCtls/xmTimeLine/index.vue'
import {StorageUtils} from 'xmgoing-utils';
import {storeToRefs} from "pinia";
import eventBus from "@/events/eventBus";
import GoingUtils from "@/utils/goingUtils";

const pageModelsStore: any = usePageModelsStore();


interface propTypes {
  pId: string,
  props: any,
  readOnlyText: boolean,
  autoLoad: boolean,
  events: any,
  queryParams: any,
  styles: any,
  list: any,
  dataConfig: any,
  model: any,
  elConfig: any,
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  pId: '',
  readOnlyText: false,
  styles: {},
  autoLoad: true,
  list: {},
  events: [],
  props: {},
  queryParams: {},
  dataConfig: {},
  model: {},
  elConfig: {},
})
const {
  queryParams,
  autoLoad,
  readOnlyText,
  dataConfig,
  props,
  styles,
  model,
  events,
  elConfig
}: any = toRefs(propsPage);

const {elCtlStyle, elBaseStyle} = useCtlStyle({styles, props, propsStyl: ['width', 'height']});
const {vuex} = useVuexState({sectionConfig: props, vuexProps: ['showCtl', 'disabled', CtlComEnum.DEFAULT_SET]});

const queryUserParams = ref({})

const imgProps = ref({
  pageCode: ''
})


const {state} = storeToRefs(pageModelsStore);
/**
 * 查询参数
 */
const initQueryUserParams = computed(() => {
  if (unref(state) && (unref(props).vuexFlag + '') === 'true') {
    return {
      id: unref(state)[unref(props)['vuexObj']],
    }
  } else if ((unref(props).sessionFlag + '') === 'true') {
    return {
      id: StorageUtils.getSessionItem("flowRecordId")||StorageUtils.getSessionItem(unref(props).sessionFieldId),
    }
  }
})

const timeLineRef = ref();
const flowLogInstanceKey = computed(() => {
  return String(unref(elConfig)?.key || unref(props)?.key || '').trim();
});

const flushFlowLog = () => {
  const inst: any = timeLineRef.value;
  if (inst?.flushList) {
    inst.flushList({});
    return;
  }
  if (inst?.initCtlDataFun) {
    inst.initCtlDataFun({});
  }
};

const flowLogEventKeys = () => {
  const outerKey = flowLogInstanceKey.value;
  return outerKey ? [outerKey] : [];
};

onMounted(() => {
  flowLogEventKeys().forEach((k) => {
    eventBus.on(k + '_flushFlowLog', flushFlowLog);
    eventBus.on(GoingUtils.getEventCtlKey(k) + '_flushFlowLog', flushFlowLog);
  });
});
onBeforeUnmount(() => {
  flowLogEventKeys().forEach((k) => {
    eventBus.off(k + '_flushFlowLog', flushFlowLog);
    eventBus.off(GoingUtils.getEventCtlKey(k) + '_flushFlowLog', flushFlowLog);
  });
});
const shoImgFlag: any = ref(false);
/**
 * 打开流程图查看
 */
const openFlowImg = function () {
  shoImgFlag.value = true;
}
</script>

<style type="text/css" lang="less">
.xmFlowLog {
  background-color: #FBFAFB;
  overflow: auto;

  .header-bar-log {
    padding: 8px 22px;

    .log-title {
      color: #333;
      font-size: 15px;
      font-weight: 500;
    }

    .log-show-body {
      padding: 22px 0;
    }

    .card-log {
      margin-top: 8px;
      background-color: #FFF;

      .ant-card-body {
        padding: 14px 22px;
      }
    }

    .log-content {
      color: #000;
      background-color: #FFF;
      font-weight: 500;
    }

    .user-info {
      margin-top: 12px;
      display: flex;
      align-items: center;

      .user-info-oper {
        padding-left: 12px;
        color: var(--primary-color, #0a6eff);
        font-weight: bold;
      }

      .user-info-label {
        padding-left: 12px;
      }
    }
  }
}
</style>
